class podorklublogin {
    constructor() {
        this.extracss = null;
        this.mobile_loginredirect = null;
    }

    showform(extracss)
    {
        this.extracss = extracss;
        $("body").toggleClass("belep_opened");
        $("body").removeClass("search_opened");
        $("body").removeClass("lang_opened");
        /*
        $.fancybox($(".podorklubloginform-kont").html(), {
               'autoDimensions' : false,
            'width' : 450,
            'height' : 300
        })
        */
        /*podorklublogin.extracss = extracss;
        $(".loginform-kont .title span").hide();
        */
        if(this.extracss!=''){
            $("."+this.extracss).show();
        }else{
            $(".login-belepes").show();
        }
        $(".loginform-kont .closeme").on("click", (e) => {
            e.preventDefault();
            $("body").removeClass("belep_opened");
            $('.podorklubloginform-error').empty();
            $('#podorklubloginform input:text, #podorklubloginform input:password').val('');
            //podorklublogin.closeform()
        });
        /*$(".layer-overlay").on("click", function(){
            podorklublogin.closeform()
        })
        $(".layer-overlay").css({
            "height": $(document).height(),
            "width": $(window).width(),
            "opacity": .8
        }).show()	*/
        //$(".loginform-kont").css("top", ( $(window).height() - $(".loginform-kont").height() ) / 2+$(window).scrollTop() + "px");
        //$(".loginform-kont").css("left", ( $(window).width() - $(".loginform-kont").width() ) / 2+$(window).scrollLeft() + "px");
        //$(".loginform-kont").fadeIn('fast')


    }

    submitform(form)
    {
        console.log(this.extracss, form)
        $(form).find(".podorklubloginform-error").remove();
        let email = $(form).find("[name='email']").val().trim();
        let kszam = $(form).find("[name='kartyaszam']").val();
        let returnurl = $(form).find("[name='returnurl']").val();
        let error = this.validateform(email, kszam);

        if (error === true)
        {
            let extrap = "";

            let urlParams = new URLSearchParams(window.location.search);

            if (urlParams.has("p"))
            {
                extrap = urlParams.get("p");
            }

            $.post('/index.php/felhasznalok/loginservice/login', {email: email, kartyaszam: kszam, p: extrap, forcelang: $('body').attr('data-aktlang')},(ret) => {
                if (ret.state == false)
                {
                    var ujrakuldeslink = "";
                    if (ret.ujrakuldes == true)
                    {
                        ujrakuldeslink = ' <a class="resend-email-message" href="#" onclick="podorklublogin.resendActivateMail(\''+email+'\')">';
                        ujrakuldeslink += lng_aktivalolevelujrakuldese;
                        ujrakuldeslink += "</a>";
                    }
                    $('<div>')
                        .addClass('podorklubloginform-error')
                        .html(ret.msg+ujrakuldeslink)
                        .prependTo($(form))
                } else {

                    if (returnurl != undefined && returnurl != '')
                    {
                        document.location.href=returnurl;
                    } else {
                        window.location.reload()
                    }
                }
            },'json')
        } else {
            $.each(error,(i,edat) => {
                $('<div>')
                    .addClass('podorklubloginform-error')
                    .text(edat.msg)
                    .prependTo($(form))
            })
        }
    }

    resendActivateMail(email) {
        $('<span>').addClass('smallblinkwaiter').text(' ...').appendTo($('.resend-email-message').parent());
        var tt = setInterval(() => {
            $('.smallblinkwaiter').animate({opacity: .2}, 200, () => {
                $('.smallblinkwaiter').animate({opacity: 1}, 200);
            });
        }, 600)
        $.post(webshopajaxurl, {fn: 'resend_aktivalomail', email: email},(ret) => {
            var msgStr = $("<strong>").text(lng_aktivalolevelujrakuldesemegtortent);
            $('.podorklubloginform-error').empty().append(msgStr);
            clearInterval(tt);

            setTimeout(() => {
                $('.podorklubloginform-error').empty();
            }, 15000)
        });
    }

    closeform()
    {
        $(".layer-overlay").hide();
        $('.podorklubloginform-error').empty()
        $('#podorklubloginform input:text, #podorklubloginform input:password').val('')
        $(".loginform-kont").fadeOut('fast')
    }

    validateform(email,kszam)
    {
        let error = false;
        let erroro = [];
        if (email == "")
        {
            error = true
            erroro.push({elem: 'email', msg: lng_mailnemlehetures})
        } else if (!/^\S+@\S+\.\S+$/.test(email)) {
            error = true
            erroro.push({elem: 'email', msg: lng_mailnemtunikervenyesnek})
        }
        if (kszam == "")
        {
            error = true
            erroro.push({elem: 'kartyaszam', msg: lng_kartyaszamnemlehetures})
        }
        if (error)
        {
            return erroro;
        } else {
            return true;
        }
    }

    klubkijelentkezes()
    {
        $.post('/index.php/felhasznalok/loginservice/logout',  () => {
            Kosar.clearSavedKosar();
            window.location.reload()
        })
    }

    changeFulek(el) {

        $('.topfulek-kont a').removeClass('aktiv');
        $(el).addClass('aktiv');

        var azon = 'klub';
        if ($(el).hasClass('klub'))
        {
            azon = 'klub';
        }

        if ($(el).hasClass('firmen'))
        {
            azon = 'firmen';
        }
        if ($(el).hasClass('lop'))
        {
            azon = 'lop';
        }

        $('.ujlogin .logindoboz').parents('.ujlogin').removeClass('ful-lop ful-klub ful-firmen').addClass('ful-'+azon);

        $('.ujlogin .regbutton-kont').addClass('hide')
        $('.ujlogin .regbutton-kont.regbutton-'+azon).removeClass('hide')

        $('.ujlogin .loginform-text.klub, .ujlogin .loginform-text.firmen, .ujlogin .loginform-text.lop').addClass('hide')
        $('.ujlogin .loginform-text.'+azon).removeClass('hide')

        var orilnk = $('.ujlogin .forgotten-password').attr('href');

        if (orilnk.indexOf('aktivful') > -1)
        {
            $('.ujlogin .forgotten-password').attr('href', orilnk.replace(/aktivful=(klub|firmen|lop)/, 'aktivful='+azon));
        } else {
            $('.ujlogin .forgotten-password').attr('href', orilnk+'&aktivful='+azon);
        }

        return false;
    }
}

export default podorklublogin;
